import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {StateService} from '@core/services/state.service';

@Component({
  selector: 'app-voucher-code-widget',
  template: '<div *renderInView #voucherWidgetRef id="voucher-widget"></div>',
  styles: [
    '#voucher-widget { overflow: hidden !important }'
  ]
})
export class VoucherCodeWidgetComponent {

  @ViewChild('voucherWidgetRef') private set voucherWidgetRef(ref: ElementRef) {
    const element: HTMLElement = ref?.nativeElement;
    if (element && StateService.isBrowser) {
      this.injectVoucherCodes(element);
    }
  }

  private async injectVoucherCodes(container: HTMLElement): Promise<void> {
    const target = encodeURIComponent(window.location.href);
    const widgetUri = `https://raba.tize.no/widget/html/krone/fanat?target=${target}`;
    const data = await fetch(widgetUri);
    container.innerHTML = await data.text();
  }

}
